import {FeatureItem} from "../../FeatureItemCard/types"

export const featuresItems: FeatureItem[] = [
	{
		icon: "analytic-percentage--business-products",
		title: "1% APY",
		description: "1% APY Deposit Account, FDIC Insurance up to $250,000 available for funds on deposit.",
	},
	{
		icon: "money-transfer--business-products",
		title: "Payments",
		description: "ACH, same-day ACH, and checks. Free, instant, 24/7 book transfers.",
	},
	{
		icon: "credit-card",
		title: "Cards",
		description: "Physical and virtual debit cards for multiple user types.",
	},
	{
		icon: "Atm-Socket-Money-Withdraw",
		title: "ATM",
		description: "ATM cash deposits and withdrawals at over a thousand fee-free locations nationwide.",
	},
	{
		icon: "Smartphone-Action-Money-Fund",
		title: "Mobile Check Deposit",
		description: "Offer your customers an easy way to deposit their check via their mobile phones.",
	},
	{
		icon: "user-multiple-new",
		title: "Role-based access",
		description: "Enable multiple authorized user types on your account for role-based access.",
	},
]

export const mockFeaturesItemsWithNotes: FeatureItem[] = [
	{
		icon: "analytic-percentage--business-products",
		title: "1% APY",
		description: "1% APY* Accounts, FDIC Insurance up to $250,000 available for funds on deposit.",
		note: {
			id: "1",
			description:
				"Accounts are eligible for pass-through deposit insurance only to the extent pass-through insurance is permitted by the rules and regulations of the FDIC, and if the requirements for pass-through insurance are satisfied. There may be a risk that pass-through deposit insurance is not available because conditions have not been satisfied. In such cases, funds may not be fully insured in the event the insured depository institution where the funds have been deposited were to fail.",
		},
	},
	{
		icon: "money-transfer--business-products",
		title: "Payments",
		description: "ACH, same-day ACH, and checks. Free, instant, 24/7 book transfers.",
	},
	{
		icon: "credit-card",
		title: "Cards",
		description: "Physical and virtual debit cards for multiple user types.",
	},
	{
		icon: "Atm-Socket-Money-Withdraw",
		title: "ATM",
		description: "ATM cash deposits and withdrawals at over a thousand fee-free locations nationwide.",
		note: {
			id: "2",
			description:
				"You can find Allpoint ATMs throughout the United States and around the globe at over 55,000 locations. https://www.allpointnetwork.com/locator",
		},
	},
	{
		icon: "Smartphone-Action-Money-Fund",
		title: "Mobile Check Deposit",
		description: "Offer your customers an easy way to deposit their check via their mobile phones.",
	},
	{
		icon: "user-multiple-new",
		title: "Role-based access",
		description: "Enable multiple authorized user types on your account for role-based access.",
	},
]
